var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.authControl
    ? _c(
        "b-btn",
        _vm._g(_vm._b({}, "b-btn", _vm.attrs, false), _vm.$listeners),
        [
          _c(
            "div",
            {
              staticClass: "brb-btn-container",
              class: [{ loading: _vm.loading }, _vm.btnClass],
            },
            [
              _vm.startIcon
                ? _c(
                    "font-awesome-icon",
                    _vm._b(
                      { staticClass: "ml-1", attrs: { icon: _vm.startIcon } },
                      "font-awesome-icon",
                      _vm.startIconAttrs,
                      false
                    )
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _vm._t("default", function () {
                    return [
                      _vm.text
                        ? _c(
                            "span",
                            { class: { "single-line": !_vm.multiline } },
                            [_vm._v(" " + _vm._s(_vm.text) + " ")]
                          )
                        : _vm.icon
                        ? _c(
                            "font-awesome-icon",
                            _vm._b(
                              { attrs: { icon: _vm.icon } },
                              "font-awesome-icon",
                              _vm.iconAttrs,
                              false
                            )
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
              _vm.endIcon
                ? _c(
                    "font-awesome-icon",
                    _vm._b(
                      { staticClass: "mr-1", attrs: { icon: _vm.endIcon } },
                      "font-awesome-icon",
                      _vm.endIconAttrs,
                      false
                    )
                  )
                : _vm._e(),
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "brb-btn-loading-wrapper" },
                    [_c("b-spinner", { attrs: { small: "" } })],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }